/**
 * @format
 */
import { api } from '@/scripts/api';

export const CurrencyService = {
    getAllCurrencies() {
        const service = '/ms/exchange-rates/v1/currencies';
        return new Promise((resolve, reject) => {
            api.get(service).then(resolve).catch(reject);
        });
    },
};
